import React from "react";
import logoPolicia from '../../assets/svg/policia.svg';

const PopupConfirmarCancelar = ({ mensaje, onClose, onConfirm }) => {

    const handleClose = () => {
        onClose();
    };

    const handleConfirm = () => {
        onConfirm();
    };

    return (
        <div>
            <div className="popup-overlay" onClick={handleClose}></div>
            <div className="popup-container">
                <img src={logoPolicia} alt="logo policia" />
                <p>{mensaje}</p>
                <div className='contenedor-horizontal'>
                    <button className='boton-primario' onClick={handleClose}>Cancelar</button>
                    <button className='boton-secundario' onClick={handleConfirm}>Confirmar</button>
                </div>
            </div>
        </div>
    );
}

export default PopupConfirmarCancelar;